/*
 * bag-cart-guard.js — site-wide guard: every handpan must always carry a bag.
 * If a handpan's bag (free or upgrade) is removed from the cart, the included
 * FREE bag is re-added automatically; the native Buy X Get Y discounts then
 * recompute (free bag -> 0, upgrade credit drops away).
 *
 * Must be loaded GLOBALLY (theme.liquid), because removal happens in the cart
 * drawer on any page — not just the PDP.
 *
 * Pairing model (set by bag-selector.js when the handpan is added):
 *   - handpan line  -> properties { _bundle: <id>, _default_bag: <free variant id> }
 *   - bag line      -> properties { _bundle: <id> }
 * A handpan whose _bundle has no matching bag line is missing its bag.
 *
 * Verified against the live theme: cart removal fires `rebuy:cart.change` and
 * `theme:cart:added` (NOT `theme:cart:refresh`), so we listen to several events.
 */
(function () {
  var working = false, timer = null;
  // Variants that /cart/add.js refused this page load (e.g. sold out).
  // Without this the guard loops forever: failed add -> drawer refresh ->
  // cart event -> retry the same unavailable variant.
  var failed = {};

  ['rebuy:cart.change', 'theme:cart:added', 'theme:cart:refresh', 'theme:cart:change', 'cart:updated']
    .forEach(function (ev) { document.addEventListener(ev, schedule); });

  function schedule() { clearTimeout(timer); timer = setTimeout(run, 150); }

  function run() {
    if (working) return;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var handpans = cart.items.filter(function (i) { return i.properties && i.properties._default_bag; });
      if (!handpans.length) return;

      // bundles that still have a bag line (bag = has _bundle but NOT _default_bag)
      var bagBundles = {};
      cart.items.forEach(function (i) {
        if (i.properties && i.properties._bundle && !i.properties._default_bag) bagBundles[i.properties._bundle] = true;
      });

      var toAdd = [];
      handpans.forEach(function (hp) {
        var b = hp.properties._bundle;
        var bagId = parseInt(hp.properties._default_bag, 10);
        if (b && !bagBundles[b] && !failed[bagId]) {
          toAdd.push({ id: bagId, quantity: 1, properties: { _bundle: b } });
        }
      });
      if (!toAdd.length) return;

      working = true;
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: toAdd })
      })
        .then(function (r) {
          if (!r.ok) {
            // Sold out / stock race: remember and never retry these variants
            // this page load — refreshing the drawer here would re-trigger us.
            toAdd.forEach(function (i) { failed[i.id] = true; });
            console.warn('[bag-guard] add refused (' + r.status + '), not retrying');
            return;
          }
          return refreshDrawer();
        })
        .catch(function (e) { console.warn('[bag-guard]', e); })
        .then(function () { working = false; });
    }).catch(function () {});
  }

  function refreshDrawer() {
    var d = document.querySelector('cart-element');
    if (!d) { document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true })); return; }
    return Promise.resolve(d.getCart && d.getCart())
      .then(function () { if (d.renderCartDrawer) d.renderCartDrawer(); })
      .catch(function () {});
  }
})();
